import Localization from "../../../localization";
import InvalidLicense from "./invalidLicense";
import { Tools } from "../../../utils";
import { Flex, QRCode } from "antd";
import Actions from "./actions";
import UnAuth from "./unAuth";
import React from "react";
import {
  ContentLoader,
  Container,
  Modal,
  Text,
  Card,
} from "../../../components";

const View = ({
  data = {},
  refs = {},
  params = {},
  loading = false,
  isAuthenticated,
  getData = () => {},
  activateLicense = () => {},
  onActivationSuccess = () => {},
}) => {
  const labels = [
    {
      name: Localization.general.subscription,
      value: `${1} ${Localization.general.year}`,
    },
    {
      name: Localization.general.total_value,
      value: Tools.toCurrency(data.amount),
    },
    {
      name: Localization.general.activation_code,
      value: Tools.maskLicenseKey(data.licenseKey),
    },
  ];

  if (!isAuthenticated) return <UnAuth />;
  else if (loading)
    return (
      <Container>
        <ContentLoader skeletons={[{ height: 330 }]} />;
      </Container>
    );
  else if (!data.licenseKey)
    return (
      <Container>
        <InvalidLicense
          uuid={params.uuid}
          onDone={(id) => getData(id, { loading: false, showError: true })}
        />
      </Container>
    );
  return (
    <Container>
      <Card title={data.serviceDescription}>
        <Flex justify="space-between">
          <Flex
            vertical
            gap={"1em"}
            children={React.Children.toArray(
              labels.map(({ name, value }) => (
                <div>
                  <Text type="disabled" children={name} />
                  <Text
                    level={4}
                    type="secondary"
                    children={value}
                    className="m-3-t"
                  />
                </div>
              ))
            )}
          />
          <QRCode value={window.location.href} size={150} />
        </Flex>
        <Actions activated={data.activated} onActivate={activateLicense} />
      </Card>
      <Modal
        closeable={false}
        ref={refs.activationSuccessModal}
        title={Localization.activate.success_title} 
        child={({ id }) => (
          <Modal.Success
            desc={Localization.activate.success_desc}
            button={{
              title: Localization.activate.success_btn,
              onClick: () => onActivationSuccess(id),
            }}
          />
        )}
      />
    </Container>
  );
};

export default View;
